import Constant from '@/const';
import axios from 'axios';

const getDinkesDataByPaymentCriteria = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/report/visitors/dinkes/payment-criteria'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getDinkesDataByPaymentCriteria;
